<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="generar-qr" titulo="QR / Sistema" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>


<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()">
                <section class="hero is-primary">
                    <div class="hero-body">

                        <!-- Opciones  -->
                        <div class="control is-grouped" style="position:absolute; top:4.5em; right:1em; z-index: 999;">
                            <p class="control">
                                <a class="button is-primary tooltip" (click)="ctrl.regresar()">
                                        <span class="icon ">
                                            <i class="icon-back"> </i>
                                        </span>
                                        <span class="tooltiptext">Regresar</span>
                                    </a>
                            </p>

                            <p class="control" *ngIf="ctrl.id">
                                <a class="button is-primary tooltip" (click)="ctrl.cargarDatos()" >
                                        <span class="icon ">
                                            <i class="icon-worldwide"></i>
                                        </span>
                                        <span class="tooltiptext">Actualizar</span>
                                    </a>
                            </p>
                        </div>
                    </div>
                </section>

                <section class="section" style="overflow: auto;padding: 1rem !important;height: 85.8vh;">

                    <h1>Escanee este codigo en la pantalla de acceso de su control de negocio movil</h1>
                    <div align="center">
                        <figure class="image" style="width:50%">
                            <img [src]="'data:image/png;base64,' + ctrl.dato.get('qr').value">
                        </figure>                    
                    </div>
                </section>
            </form>
        </div>
    </div>
</div>